<template>
  <div class="container">
    <el-row type="flex" justify="center" class="wrap-row"  style="white-space:normal">
      <el-col class="wrap-col" :xs="24" :sm="24" :md="14" :lg="14" :xl="14">
      <h3>{{$t('guestID.uploadPassport')}}</h3>
      <div class="content">
        <div class="content-item" v-for="(item, index) in identificationInfo.identifications" :key="index">
          <div class="title-box">
            <div class="title">
              <p>{{$t('guestID.photo')}}<span>*</span></p>
            </div>
            <i class="el-icon-delete" style="color: #FF0000" @click="deleteIdentifications(index)" v-if="index !== 0 && !item.id"></i>
          </div>
            <Upload v-if="item.status != 'PASS'" :openOrderId='openOrderId' :imgInfo="item" @successHandle="successHandle" :index="index"></Upload>
            <img v-else :src="item.img.url" class="avatar">
            <p class="tip" v-if="item.status === 'REJECTED'"><i class="el-icon-circle-close"></i>{{item.rejectReason == 'NOT_PASSPORT' ? $t('guestID.notPassport') : $t('guestID.imgNOtClear')}}</p>
          </div>
        <div class="button">
          <el-button round plain type="primary" icon="el-icon-circle-plus-outline" @click="addItem">{{$t('guestID.addGuest')}}</el-button>
          <el-button type="primary" style="width: 200px;margin-top:30px" @click="submitHandle">{{$t('guestID.confirm')}}</el-button>
        </div>
      </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Upload from '@/components/identification/Upload.vue'
import { update } from '@/api/identification'
export default {
  components: { Upload },
  props: {
    identificationInfo: Object,
  },
  data () {
    return {
      list: [],
      openOrderId: null,
    }
  },
  created () {
    console.log(this.identificationInfo)
    this.init()
  },
  methods: {
    init () {
      this.openOrderId = this.$route.params.openOrderId
    },
    addItem () {
      this.identificationInfo.identifications.push({
        img: {
          id: null,
        },
      })
    },
    successHandle (fileInfo) {
      console.log(fileInfo)
      this.identificationInfo.identifications[fileInfo.index].img = {
        id: fileInfo.id.toString(),
        url: `https://ostay-test.oss-ap-northeast-1.aliyuncs.com/${fileInfo.fileKey}`,
      }
    },
    submitHandle () {
      const info = this.$cookie.getCustomerInfo()
      update({
        identifications: this.identificationInfo.identifications.map(item => {
          return { imgId: item.img.id, id: item.id }
        }),
        token: info.token,
      }).then(res => {
        if (res.errCode === '200') {
          this.$emit('upload-success')
          this.$message.success(res.errMsg)
          this.$emit('getList')
          console.log(res.data)
          // this.historys = [{ imgUrl: res.data && res.data.imgUrl, status: 'WAIT' }]
          // this.config.fileList = []
        } else {
          this.$message.error(res.errMsg)
          // this.config.fileList = []
        }
      })
    },
    deleteIdentifications (index) {
      this.identificationInfo.identifications.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
/deep/.el-col {
  white-space: normal;
}
.container {
  // height: 100%;
}
.wrap-row {
  // height: 100%;
}
.content {
  height: 100%;
  width: 100%;
  background-color: #F5F7FA;
  padding: 20px;
  box-sizing: border-box;
  // overflow: scroll;
  .content-item {
    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      color: #818388;
      span {
        color: #FF0000;
      }
    }
    .title::before {
      content: '';
      // position: absolute;
      width: 2px;
      height: 15px;
      background-color: #B59429;
    }
  }
}
h3 {
  text-align: center;
  font-size: 18px;
}
.button {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 15px;
  flex-direction: column;
}
.title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
}
.tip {
  color: #EB4D4D;
  font-size: 14px;
}
.avatar {
  width: 178px;
  height: 98px;
  display: block;
  object-fit: contain;
}
</style>
